export default "__VITE_ASSET__DULehjN9__ 72w";